"use client"
import { graphql } from "@opensea/graphql"
import { CurrencyStatsSubscriptionFragment } from "@/hooks/api/use-currency-stats-subscription"
import { CurrencyStatsTableRowFragment } from "../CurrencyStatsTable/CurrencyStatsTableRow"

export const TopCurrencyStatsTableQuery = graphql(
  `
    query TopCurrencyStatsTableQuery(
      $cursor: String
      $sort: CurrenciesSort!
      $filter: CurrenciesFilter!
      $limit: Int!
      $slug: CurrencySlug
    ) {
      topCurrencies(
        cursor: $cursor
        sort: $sort
        filter: $filter
        limit: $limit
        slug: $slug
      ) {
        items {
          id
          name
          contractAddress
          chain {
            identifier
          }
          __typename
          ...CurrencyStatsTableRow
          ...CurrencyStatsSubscription
        }
        nextPageCursor
      }
    }
  `,
  [CurrencyStatsTableRowFragment, CurrencyStatsSubscriptionFragment],
)
